import React from 'react';
import { X } from 'lucide-react';

interface StateFormProps {
  state: {
    code: string;
    name: string;
    about_template: string;
    why_choose_us_template: string;
    benefits_template: string;
  };
  onChange: (field: string, value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onCancel: () => void;
  isSubmitting: boolean;
}

export function StateForm({ state, onChange, onSubmit, onCancel, isSubmitting }: StateFormProps) {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-gray-900">
          {state.code ? 'Edit State' : 'Add State'}
        </h3>
        <button
          type="button"
          onClick={onCancel}
          className="p-2 text-gray-400 hover:text-gray-500"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          State Code
        </label>
        <input
          type="text"
          value={state.code}
          onChange={(e) => onChange('code', e.target.value)}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          required
          maxLength={2}
          placeholder="e.g., CA"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          State Name
        </label>
        <input
          type="text"
          value={state.name}
          onChange={(e) => onChange('name', e.target.value)}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          required
          placeholder="e.g., California"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          About Template
        </label>
        <textarea
          value={state.about_template}
          onChange={(e) => onChange('about_template', e.target.value)}
          rows={3}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          placeholder="Use {city} as a placeholder for city name"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Why Choose Us Template
        </label>
        <textarea
          value={state.why_choose_us_template}
          onChange={(e) => onChange('why_choose_us_template', e.target.value)}
          rows={3}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          placeholder="Use {city} as a placeholder for city name"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Benefits Template
        </label>
        <textarea
          value={state.benefits_template}
          onChange={(e) => onChange('benefits_template', e.target.value)}
          rows={3}
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          placeholder="Use {city} as a placeholder for city name"
        />
      </div>

      <div className="flex justify-end space-x-3">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={isSubmitting}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
        >
          {isSubmitting ? 'Saving...' : 'Save'}
        </button>
      </div>
    </form>
  );
}